import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { scoreValues } from "../../API/config";
import styles from "./styles";

const useStyles = makeStyles(styles);

const ScoreIndicator = (props) => {
  const { score, label, expired } = props;
  const classes = useStyles();

  let scoreClass = classes.scoreLow;
  if (score === scoreValues.blocked) {
    scoreClass = classes.scoreBlocked;
  } else if (score === scoreValues.high) {
    scoreClass = classes.scoreHigh;
  } else if (score === scoreValues.medium) {
    scoreClass = classes.scoreMedium;
  } else if (score === scoreValues.low) {
    scoreClass = classes.scoreLow;
  } else {
    scoreClass = classes.noScore;
  }

  let crossedClass = "";
  if (expired) {
    crossedClass = classes.crossed;
  }

  if (label) {
    return (
      <Grid container justify="flex-start">
        <Grid item>
          <div className={`${classes.borderedSquare} ${scoreClass}`} />
        </Grid>
        <Grid item>
          <Typography component="div" className={classes.label}>
            {label}
          </Typography>
        </Grid>
      </Grid>
    );
  }
  return (
    <Grid container justify="flex-start">
      <Grid item>
        <Grid
          container
          item
          justify="center"
          alignItems="center"
          className={`${classes.borderedSquare} ${scoreClass} ${crossedClass}`}
        ></Grid>
      </Grid>
    </Grid>
  );
};

export default ScoreIndicator;
